import InternalBanner from "./InternalBanner";

export default InternalBanner;
